import { Route, Routes } from 'react-router-dom';

import { ErrorPage } from '~/components/ErrorPage';
import { hasDdexConsoleAccess } from '~/lib/navigationPermissions';

import { useUser } from '../auth/hooks/useUser';
import { DdexConsole } from './components/DdexConsole';

const Router = () => {
  const { hasPermission } = useUser();
  const canAccessDdexConsole = hasDdexConsoleAccess(hasPermission);

  return (
    <Routes>
      {canAccessDdexConsole ? <Route index element={<DdexConsole />} /> : null}

      <Route path="*" element={<ErrorPage type="notFoundPage" />} />
    </Routes>
  );
};
Router.displayName = 'DdexConsoleRouter';

export { Router };
